<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link to="/branch">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to stores overview </span>
			</router-link>
		</div>
		<base-page-heading
			title="Branch Edit"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updatePickupStoresProperties"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>

		<div class="row content">
			<EditPickupStoresTable
				ref="editpickupstores"
				:route-id="$route.params.id"
			/>
		</div>
	</div>
</template>

<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
